import { put, takeLatest } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import { Notify } from '@flexisaf/flexibull2';
import { TOP_RIGHT, SUCCESS } from 'utils/constants';
import { updateGroupFailure, updateGroupSuccess } from '../actions';
import GroupActionTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';


const { API_BASE_URL } = urls || {};

function* updateGroup({ payload: { data: payload, cb } }) {
  const groupData = {
    name: payload.name,
  };
  const url = `${API_BASE_URL}/application-groups/${payload.id}`;

  const response = yield request({
    method: 'put',
    data: groupData,
    url,
  });
  if (response.success) {
    yield put(updateGroupSuccess(response.raw));
    Notify('Group Updated Successfully!', {
      position: TOP_RIGHT,
      status: SUCCESS,
    });
    cb();
  } else {
    yield put(
      updateGroupFailure(
        'An error occured. Please reload the page to try again.'
      )
    );

    const errorMesssage = response.statusCode === 409 ? 'Group already exists' : response.message;
    networkErrorHandler(response?.statusCode, errorMesssage);
  }
}

export function* onUpdateGroup() {
  yield takeLatest(GroupActionTypes.UPDATE_GROUP, updateGroup);
}
